class SearchResults {
    constructor(rawResults = null, extraEntries = []) {
        if (rawResults) {
            this._entries = extraEntries.concat(rawResults.entries);
            this._totalCount = rawResults.resultsCount;
            this._aggregations = rawResults.aggregations;
        } else {
            this._entries = extraEntries;
            this._totalCount = 0;
            this._aggregations = [];
        }
    }

    get entries() {
        return this._entries;
    }

    set entries(entries = []) {
        this._entries = entries;
    }

    get totalCount() {
        return this._totalCount;
    }

    set totalCount(totalCount = 0) {
        this._totalCount = totalCount
    }

    get aggregations() {
        return this._aggregations;
    }

    set aggregations(aggregations = []) {
        this._aggregations = aggregations;
    }

    get count() {
        return this._entries.length;
    }
}

export default SearchResults;